export default __webpack_public_path__ + "static/media/logovtfc.d20c79da.png?v=elephant-20261103";